import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from '../../services/api';
import Header from '../../Header';
import SideMenu from '../../SideMenu';
import Footer from '../../Footer';
import DataTable from 'react-data-table-component';

export default function List_Fabricantes({ history }) {
const [prod, setProd] = useState([]);
const [loading, setLoading] = useState("");
const [busca, setBusca] = useState('');
const [rowsSel, setRowsSel] = useState([]);

const empresaid = localStorage.getItem("sgiempresaid");
const isMaster = localStorage.getItem("sgimaster");
const isMasterUser = isMaster === "true";
/** Não-master só altera/remove treinamentos com idempresa igual ao tenant; master altera qualquer um. */
const ehDaMinhaEmpresa = (row) =>
  row && String(row.idempresa) === String(empresaid);
const podeAlterarTreinamento = (row) => isMasterUser || ehDaMinhaEmpresa(row);

const url_string = window.location.href;
const param = url_string.split("/");

async function loadProd() {
  const headers = { "x-tenantid": empresaid, "isMaster": isMaster };
  let data = [];

  if (isMaster === "true") {
    const response = await api.get("/treinamentos/produto", { headers });
    data = response.data || [];
  } else {
    try {
      const er = await api.get("/treinamentos/empresa/" + empresaid);
      const row = er.data && er.data[0];
      const permitidos = (row && row.treinamentosPermitidos) || [];
      const ids = permitidos.map((x) => String(x));

      if (ids.length === 0) {
        data = [];
      } else {
        const body = ids.map((id) => ({ id }));
        const resp = await api.post("/treinamentos/produto/idlist", body, {
          headers,
        });
        data = (resp.data || []).filter((p) => !p.isIntegracao);
      }
    } catch (e) {
      data = [];
    }
  }

  setProd(
    data.filter(
      (item) =>
        item.titulo &&
        item.titulo.toLowerCase().includes(busca.toLowerCase())
    )
  );
  setLoading(false);
};

function efetivaBusca(){
  loadProd();
};

const goToPage = (state) => {
  if (!podeAlterarTreinamento(state)) {
    alert(
      "Este treinamento não pertence à sua empresa. Você pode visualizá-lo na lista, mas não editá-lo."
    );
    return;
  }
  history.push('/produto/' + state._id);
};

const columns = [
  {
    name: 'Titulo',
    selector: row => row.titulo,
    wrap:true,
    sortable: true
  },
  {
    name: 'Descrição',
    selector: row => row.descr,
    wrap:true,
    sortable: true
  },
  ...(isMasterUser
    ? [
        {
          name: 'Tipo',
          cell: row => {
            const avul = row.avulso === true;
            const corp = row.corporativo !== undefined ? row.corporativo : !avul;
            if (corp && avul) return 'Corporativo e Avulso';
            if (avul) return 'Avulso';
            return 'Corporativo';
          },
          sortable: true,
          width: '160px'
        },
        {
          name: 'Valor (R$)',
          cell: row => {
            const valor = row.valor ?? row.valorTreinamento;
            if (row.avulso === true && valor !== undefined && valor !== null) {
              return parseFloat(valor).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
            }
            return '-';
          },
          sortable: true,
          width: '120px'
        }
      ]
    : [])
];

const handleChange = (state) => {
  setRowsSel(state.selectedRows)
};

  useEffect(() => {
    setLoading(true);
    loadProd();
    if(param[3] == 'produtos'){
      setTimeout(() => {
        if(document.getElementById('menu_produto')){
          document.getElementById('menu_produto').className = "active";
        }      
      }, 50);
    } else {
      setTimeout(() => {
        if(document.getElementById('menu_integracao')){
          document.getElementById('menu_integracao').className = "active";
        }      
      }, 50);
    }
    
  }, []);

  async function handleRemove(id, item){
    if(rowsSel.length > 0){
      if (window.confirm('Confirma remoção dos itens selecionados ?')){
        setLoading(true);
        rowsSel.map(async (item) => {
            await api.delete('/treinamentos/produto/' + item._id, {
              headers: { "x-tenantid": empresaid, isMaster },
            }).then((res) => {
              if(res.data.error != undefined){
                  alert(res.data.error);
                  setLoading(false);
                  return;
              } else {
                loadProd();
                setLoading(false);
              }
          }).catch((error) => {
              alert(error);
              setLoading(false);
              return;
          });    
        });
      }
  } else {
    alert("Nenhum registro selecionado !")
  }
};

  return (
    <>

    <Header/>
    <SideMenu/>

    <div>
        <div className="content-wrapper">

            <section className="content-header">
                <h1>
                    Treinamentos<small> - Gerenciamento de cursos e treinamentos</small>
                </h1>
            </section>

            <section className="content">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="box">
                        {loading && (
                          <div style={{ alignItems: "center", textAlign: "center" }}>
                            <img src={carregando} width="80" alt=""></img>
                          </div>
                        )}
                        <div className="box-body table-responsive">
                            

                            <div className="col-md-12 nopadding" style={{marginBottom: '20px'}}>
                        <div className="col-md-6 nopadding">
                        <button type="button" className="btn btn-success margin" onClick={() => {history.push('/produto/novo')}}>
                          <i className="fa fa-plus" style={{marginRight: '5px'}}></i>
                          Novo Treinamento
                        </button>
                          <button type="button" className="btn btn-danger margin" onClick={() => {handleRemove('','')}}>
                            <i className="fa fa-trash" style={{marginRight: '5px'}}></i>
                            Remover Selecionados
                          </button>
                          </div>
                          <div className="col-md-6 text-right" style={{paddingTop:10}}>
                          <div style={{display: 'inline-flex', gap: '10px'}}>
                          <input
                              className="form-control"
                              style={{width: '250px', display: 'inline-block'}}
                              placeholder="Buscar por nome..."
                              value={busca}
                              onChange={event => setBusca(event.target.value)}
                            />
                            <button 
                              className="btn btn-primary"
                              onClick={efetivaBusca}
                            >
                              <i className="fa fa-search" style={{marginRight: '5px'}}></i>
                              Buscar
                            </button>
                            </div>
                            </div>
                          </div>
                        

                            <DataTable
                          columns={columns}
                          data={prod}
                          onRowClicked={goToPage}
                          selectableRows
                          selectableRowDisabled={(row) =>
                            !isMasterUser && !ehDaMinhaEmpresa(row)
                          }
                          pointerOnHover
                          highlightOnHover
                          onSelectedRowsChange={handleChange}
                          noDataComponent={''}
                        />

                            </div>

                         
                        </div>
                        {/* /.box */}
                    </div>
                </div>
            </section>
            {/* /.content */}
        </div>
    </div>
    
    <Footer/>
    </>
)
}


//nome, 
//descr, 
//preco, 
//imagem, 
//promocao, 
//idestabelecimento
